/* member-invite-redirect.js — résout ?land=…&sprache=… vers le lien nskn.co.
 *
 * Cible des e-mails d'invitation (SPEC-0006). Voir
 * sections/member-invite-redirect.liquid pour le pourquoi de l'indirection.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-invite-redirect]');
  if (!root) return;

  var DATA = window.MEMBER_INVITE_LINKS || {};
  var params = new URLSearchParams(window.location.search);

  function slugify(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function resolve() {
    var land = slugify(params.get('land'));
    var sprache = slugify(params.get('sprache'));
    var entry = DATA[land];
    if (!entry) return null;

    var langs = Object.keys(entry.sprachen);
    // Langue absente ou inconnue : si le pays n'en a qu'une, le choix est
    // évident. Sinon on tente l'anglais, présent sur presque tous les marchés,
    // plutôt que d'envoyer la personne dans le mur.
    if (!entry.sprachen[sprache]) {
      sprache = langs.length === 1 ? langs[0]
              : (entry.sprachen.englisch ? 'englisch' : null);
    }
    return sprache ? entry.sprachen[sprache].link : null;
  }

  /* Repli quand l'e-mail ne transmet que la langue.
   *
   * On ne maîtrise pas ce que Shopify Email sait injecter comme Liquid dans un
   * envoi déclenché par Flow. Si le paramètre `land` manque, on s'en sort :
   * 11 des 17 langues servies ne concernent qu'un seul pays livré, la
   * redirection reste automatique. Pour les 6 autres (anglais, allemand,
   * français, néerlandais, suédois, italien) on demande le pays, une question
   * et c'est réglé — bien mieux qu'une impasse. */
  function countriesForLanguage(sprache) {
    return Object.keys(DATA).filter(function (slug) {
      return DATA[slug].sprachen[sprache];
    }).sort(function (a, b) {
      return DATA[a].land.localeCompare(DATA[b].land);
    });
  }

  function askCountry(sprache) {
    var list = countriesForLanguage(sprache);
    if (!list.length) return false;
    if (list.length === 1) {
      go(DATA[list[0]].sprachen[sprache].link);
      return true;
    }
    var picker = root.querySelector('[data-invite-picker]');
    var select = picker && picker.querySelector('select');
    if (!picker || !select) return false;

    select.options.length = 0;
    var ph = new Option(select.getAttribute('data-placeholder') || 'Land', '');
    ph.disabled = true; ph.selected = true;
    select.appendChild(ph);
    list.forEach(function (slug) {
      select.appendChild(new Option(DATA[slug].land, slug));
    });
    select.addEventListener('change', function () {
      var hit = DATA[select.value] && DATA[select.value].sprachen[sprache];
      if (hit) go(hit.link);
    });
    var state = root.querySelector('[data-invite-state]');
    if (state) state.hidden = true;
    picker.hidden = false;
    return true;
  }

  function go(url) {
    // Le bouton est posé AVANT de partir : si la redirection est bloquée
    // (certains clients mail ouvrent les liens dans une vue restreinte), la
    // personne garde un lien cliquable au lieu d'un écran mort.
    var anchor = root.querySelector('[data-invite-target]');
    if (anchor) anchor.href = url;
    show('[data-invite-manual]');

    // Immédiat, et replace() plutôt que href : la page intermédiaire ne reste
    // pas dans l'historique, donc le bouton Retour du navigateur ramène à
    // l'e-mail et non dans la redirection.
    window.location.replace(url);
  }

  function show(sel) {
    var el = root.querySelector(sel);
    if (el) el.hidden = false;
  }

  var link = resolve();
  if (link) {
    go(link);
  } else if (!askCountry(slugify(params.get('sprache')))) {
    var state = root.querySelector('[data-invite-state]');
    if (state) state.hidden = true;
    show('[data-invite-error]');
  }
})();
